import { HAVEN_ID, ADMIRAL_ID, NIG_ID, RSA_ID } from "../const/policies"

export const getFNOLClaimsAdminNumber = (capacityProviderId: string) => {
  switch (capacityProviderId) {
    case HAVEN_ID:
      return `01134871074`
    case ADMIRAL_ID:
      return `03442438657`
    case NIG_ID:
    case RSA_ID:
      return `03300413774 `
    default:
      return `03448562215`
  }
}
